import React from "react";
import Styles from "./BrandDesign.module.scss";

const BrandDesign = () => {
  return (
    <div className={Styles.brandDesign}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 10 10"
        preserveAspectRatio="xMidYMin meet"
      >
        <rect
          className={Styles.first}
          width="1000%"
          height="1000%"
          fill="#72f887"
          transform="rotate(45 100 50) translate(-5 0)"
        ></rect>
        <rect
          className={Styles.second}
          width="1000%"
          height="1000%"
          fill="#ffffff"
          transform="rotate(45 100 50) translate(-3 0)"
        ></rect>
      </svg>
    </div>
  );
};

export default BrandDesign;
